import { ReactElement } from "react";

type Tone = "active" | "blocked" | "expired" | "neutral" | "warn";

const TONE_STYLES: Record<Tone, string> = {
  active:
    "bg-emerald-50 text-emerald-700 border-emerald-200/80 ring-emerald-200/40",
  blocked: "bg-rose-50 text-rose-700 border-rose-200/80 ring-rose-200/40",
  expired:
    "bg-slate-100 text-slate-600 border-slate-200/80 ring-slate-200/40",
  neutral: "bg-slate-50 text-slate-700 border-slate-200/80 ring-slate-200/40",
  warn: "bg-amber-50 text-amber-700 border-amber-200/80 ring-amber-200/40",
};

interface Props {
  status: string;
  tone?: Tone;
}

const STATUS_DA: Record<string, string> = {
  active: "Aktiv",
  blocked: "Blokeret",
  expired: "Udløbet",
  open: "Åben",
  closed: "Lukket",
  adjusted: "Justeret",
  "no plan": "Ingen plan",
};

export function StatusPill({ status, tone }: Props): ReactElement {
  const lower = status.toLowerCase();
  const inferred: Tone =
    tone ??
    (lower === "active"
      ? "active"
      : lower === "blocked"
        ? "blocked"
        : lower === "expired"
          ? "expired"
          : "neutral");

  const label = STATUS_DA[lower] ?? status;

  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 text-[11px] font-medium uppercase tracking-wider border rounded-sm ring-1 ring-inset ${TONE_STYLES[inferred]}`}
    >
      <span
        className={`h-1.5 w-1.5 rounded-full ${
          inferred === "active"
            ? "bg-emerald-500"
            : inferred === "blocked"
              ? "bg-rose-500"
              : inferred === "warn"
                ? "bg-amber-500"
                : "bg-slate-400"
        }`}
      />
      {label}
    </span>
  );
}
